/**
 * Normaliza `detail` de respuestas FastAPI (string legacy u objeto con code/message).
 */

export type StructuredApiErrorDetail = {
  code: string;
  message: string;
};

export function parseFastApiErrorDetail(detail: unknown): {
  errorMessage: string;
  errorCode?: string;
} {
  if (detail && typeof detail === 'object' && !Array.isArray(detail)) {
    const record = detail as Record<string, unknown>;
    const code = typeof record.code === 'string' ? record.code : undefined;
    const message =
      typeof record.message === 'string'
        ? record.message
        : typeof record.detail === 'string'
          ? record.detail
          : '';
    if (code || message) {
      return { errorMessage: message || code || 'Error', errorCode: code };
    }
  }
  if (typeof detail === 'string') {
    return { errorMessage: detail };
  }
  if (detail != null) {
    return { errorMessage: String(detail) };
  }
  return { errorMessage: 'Error' };
}
